export default __webpack_public_path__ + "static/media/8t.0861e1c7.jpg";